import { globalSearchParamsSchema } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_SYSTEM_ID = 'systemId'

export const systemLensSearchParams = z.object({
  ...globalSearchParamsSchema.shape,
  [SEARCH_PARAM_SYSTEM_ID]: z.string().optional(),
})

export type SystemLensSearch = z.infer<typeof systemLensSearchParams>
